var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.913086,
    width: 72.6601,
    height: 72.6601,
    rx: 36.3301,
    fill: "#7A7A7A",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M57.678 19.6797H16.8096L18.3233 52.6015H56.1643L57.678 19.6797Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M57.678 19.6836H16.8096L35.6351 33.7315H39.1357L57.678 19.6836Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.2129 52.6041L37.2426 37.2773L54.2723 52.6041H20.2129Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2172 22.5217C20.2172 20.9551 18.948 19.6836 17.3791 19.6836C15.8125 19.6836 14.541 20.9551 14.541 22.5217C14.541 28.5657 14.541 42.6857 14.541 49.1997C14.541 51.0819 16.0668 52.6054 17.9467 52.6054C19.1546 52.6054 20.2172 52.6054 20.2172 52.6054C20.2172 52.6054 20.2172 30.5115 20.2172 22.5217Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2715 22.5217C54.2715 20.9551 55.5429 19.6836 57.1096 19.6836C57.1118 19.6836 57.1141 19.6836 57.1141 19.6836C58.6807 19.6836 59.9477 20.9528 59.9477 22.5171C59.9477 28.5589 59.9477 42.6834 59.9477 49.1997C59.9477 51.0819 58.4242 52.6054 56.542 52.6054C55.3363 52.6054 54.2715 52.6054 54.2715 52.6054C54.2715 52.6054 54.2715 30.5115 54.2715 22.5217Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9555 24.976C15.3039 24.5991 14.8293 23.9816 14.6341 23.255C14.4388 22.5285 14.541 21.7565 14.9179 21.1049C14.9179 21.1049 14.9201 21.1026 14.9201 21.1003C15.297 20.4487 15.9169 19.9742 16.6434 19.7789C17.37 19.5837 18.1442 19.6858 18.7958 20.0627L37.2434 30.7135L55.6955 20.0605C56.3471 19.6836 57.1191 19.5814 57.8456 19.7766C58.5722 19.9719 59.1897 20.4464 59.5666 21.0981L59.5689 21.1003C59.9458 21.752 60.048 22.5285 59.8527 23.255C59.6575 23.9816 59.1807 24.6014 58.529 24.9783L42.9196 33.9898L37.2434 37.2683L31.5672 33.9898L15.9555 24.976V24.976Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/Gmail.358d9acf8a7590e58b058ad51655a533.svg";
export { ForwardRef as ReactComponent };